import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';
import UserAvatar from '../UserAvatar';

const UserCard = props => (
  <div style={styles.wrapper} onClick={props.onClick} role="presentation">
    {props.profile && (
      <div style={styles.wrapper}>
        <div style={styles.nameWrapper}>
          <p style={styles.displayName}>{props.profile.displayName}</p>
          <p style={styles.organization}>Horizon New Media</p>
        </div>
        <UserAvatar
          src={
            props.profile.avatarUrl ||
            'http://cf.ltkcdn.net/socialnetworking/images/std/168646-425x425-Cat-Avatar-Primary.jpg'
          }
        />
      </div>
    )}
  </div>
);

UserCard.propTypes = {
  profile: PropTypes.shape({
    avatarUrl: PropTypes.string,
    displayName: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
};

UserCard.defaultProps = {
  onClick: () => {},
};

export default UserCard;



// WEBPACK FOOTER //
// ./src/components/UserCard/index.js